<template>
    <page-content bgClass="bg-#0E0E0E" :triggered="triggered" :more="more" needMore @scrolltolower="scrolltolower"
        @refresherpulling="refresherpulling" finishedText=" ">
        <template v-slot:navBar>
            <nav-bar :title="info.title || '资讯详情'" :showBack="true"></nav-bar>
        </template>
        <template v-slot:content>
            <div class="w-full px-30 py-24 min-h-[calc(100vh-88px)]">
                <div class="border-b border-b-solid border-#333 py-30">
                    <div>
                        <span class="text-36 text-white">{{info.title}}</span>
                    </div>
                    <div class="mt-50">
                        <span class="text-24 text-#9198AB">{{info.created_at}}</span>
                    </div>
                </div>
                <div class="rich-text mt-40 text-26 text-#ccc" v-html="info.content"></div>
            </div>
        </template>
		<template v-slot:menuBar>
		</template>
		<template v-slot:popup>
		</template>
	</page-content>
</template>

<script>
import utils from "@/utils/utils.js";
import router from "@/router";
import {getShowAddress, setShowAddress} from "@/libs/util";
import {ajaxData} from "@/request/ajax";
export default {
	data() {
		return {
			triggered: false,
			queryInfo: {
				id: 0
			},
			info: {
                title: "",
				content: "",
                created_at: "",
			},
			more: 1,
		};
	},
	created() {
        let vm = this
		this.queryInfo.id = router.currentRoute?.query.id;
        vm.getIndex()
	},
	methods: {
        getIndex() {
            let vm = this
            ajaxData("/news/info", {
                id:vm.queryInfo.id
            }).then(response => {
                vm.info.title = response.data.info.title
                vm.info.content = response.data.info.content
                vm.info.created_at = response.data.info.created_at
                console.log(response)

            })
        },
		scrolltolower() {
			console.log("滚动到底部/右边");
			this.triggered = true;
			setTimeout(() => {
				this.more = 0;
				this.triggered = false;
			}, 1000)
		},
		refresherpulling() {
			this.triggered = true;
			setTimeout(() => {
				this.triggered = false;
			}, 200)
			console.log("下拉刷新");
		}
	},
};
</script>

<style>
.rich-text img {
	max-width: 100%;
}
</style>
